import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  tone?: 'gold' | 'outline';
  size?: 'md' | 'lg' | 'block';
  className?: string;
};
export function CtaButton({
  children,
  href = '#precio',
  tone = 'gold',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const tones = {
    gold: 'bg-gold-soft text-night hover:bg-gold-bright focus-visible:outline-gold-soft',
    outline: 'border border-gold-soft/50 text-gold-soft hover:border-gold-soft hover:bg-gold-soft/10 focus-visible:outline-gold-soft'
  };
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base',
    block: 'w-full px-6 py-4 text-base'
  };
  const isExternal = href.startsWith('http');
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`inline-flex items-center justify-center gap-2 rounded-full text-center font-semibold tracking-tight transition-[transform,background-color,border-color] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${tones[tone]} ${sizes[size]} ${className}`} style={{
    fontSize: "20px"
  }} data-id="element-38" data-mp="vcbp4gpfuaen">
      {children}
    </a>;
}